import React from 'react';
import { motion } from 'framer-motion';
import { trackAddToCart } from '../lib/pixel';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  className?: string;
}
const CHECKOUT_URL = 'https://metodoadorm.shop/cart/53835557962069:1';
export const Button: React.FC<ButtonProps> = ({
  children,
  className = '',
  onClick,
  ...props
}) => {
  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    if (onClick) onClick(e);
    trackAddToCart({
      content_name: 'Método ADORMECER',
      content_ids: ['53835557962069'],
      content_type: 'product',
      value: 6.39,
      currency: 'EUR'
    });
    window.location.href = CHECKOUT_URL;
  };
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} onClick={handleClick} className={`bg-terracotta hover:bg-terracottaHover text-white font-medium py-4 px-8 rounded-full shadow-sm transition-colors duration-300 text-lg md:text-xl w-full md:w-auto ${className}`} {...props} data-id="element-14">
      {children}
    </motion.button>;
};